import React, { useEffect } from 'react';
import './TermsPrivacy.scss';

const tg = window.Telegram.WebApp;

const Terms = () => {
    useEffect(() => {
        tg.BackButton.show();
        tg.BackButton.onClick(() => {
            tg.BackButton.hide();
            window.history.back();
        });

        return () => {
            tg.BackButton.hide();
            tg.BackButton.offClick();
        };
    }, []);

    return (
        <div className="termsPrivacy">
            <h1>Deadline ML – Terms of Use</h1>
            <p>Welcome to Deadline ML ML, a Telegram mini-app that provides AI-driven estimations of potential lifespan and offers suggestions for extending life expectancy through its Full-access (premium version). Please read these Terms of Use carefully before using the app.</p>
            <div className="termsPrivacy__content">
                <h2>Acceptance of Terms</h2>
                <p>By accessing and using Deadline ML, you agree to these Terms of Use. If you do not agree, please refrain from using the app.</p>

                <h2>Changes to the Terms</h2>
                <p>We may update these Terms at any time. If we make significant changes, we will notify you within the app. Your continued use after changes means you accept the new terms.</p>
                
                <h2>Privacy and Data Usage</h2>
                <p>Your privacy is important to us. Deadline ML processes data strictly for providing its services and does not share personal information with third parties. Full details are available in our Privacy Policy.</p>

                <h2>Service Description</h2>
                <p>Deadline ML offers an AI-powered estimation of potential lifespan and insights into factors influencing longevity. Premium users gain access to personalized suggestions for improving lifestyle and extending their estimated lifespan.</p>
                
                <h2>Limitations and Disclaimer</h2>
                <ul>
                    <li>Deadline ML does not provide medical, legal, or financial advice. The app’s estimations are for entertainment and informational purposes only.</li>
                    <li>AI-generated results should not be interpreted as definitive predictions.</li>
                    <li>We do not guarantee accuracy or reliability of the information provided.</li>
                </ul>

                <h2>User Responsibilities</h2>
                <p>By using Deadline ML, you agree to:</p>
                <ul>
                    <li>Use the app responsibly and ethically.</li>
                    <li>Not manipulate AI predictions or abuse app functionalities.</li>
                    <li>Acknowledge that all content is for personal use and cannot be used for commercial purposes.</li>
                </ul>
                
                <h2>Subscriptions & Payments</h2>
                <ul>
                    <li>Full-access (premium version) grants users advanced insights and recommendations.</li>
                    <li>Subscription fees, renewal terms, and cancellation policies will be clearly stated within the app.</li>
                </ul>

                <h2>Intellectual Property</h2>
                <p>All content, AI models, and software related to Deadline ML are protected intellectual property. Users may not reproduce, distribute, or modify any part of the service.</p>
                
                <h2>Limitations of Liability</h2>
                <p>To the maximum extent permitted by law, Deadline ML is not liable for any decisions made based on AI-generated predictions or recommendations.</p>
                
                <h2>Dispute Resolution</h2>
                <p>Any disputes shall be resolved through individual arbitration. Users waive the right to class-action lawsuits.</p>
                
                <h2>Termination of Use</h2>
                <p>We reserve the right to suspend or terminate access to Deadline ML for violations of these Terms.</p>
                <p>For further inquiries, please contact the Deadline ML team via the official Telegram group - t.me/deadlineml.</p>
            </div>
        </div>
    );
};

export default Terms;
